import { Message, RequestProgress, SendMessageCallbacks } from './Communication';
import { Brakesman } from './Filesystem/Helper';
import { SharePayloadEntry, ShareableEntry } from './ShareUtils';

import { MessageTimeout, sendMessage } from './Communication';
import { getPayloadEntry } from './ShareUtils';

import utils = egr.wcf.utils;
import { cancelDownload } from './AppAction';
import { wrapForSingleUse } from '../utils/Helper';

export function shareText(content: string): Promise<void> {
    return sendMessage<Message<{content: string}>>({
        type: 'share',
        action: 'message',
        arguments: {
            content
        }
    });
}

interface PayloadEntries {
    payload: Array<SharePayloadEntry>;
}

export async function share(
    entry: ShareableEntry,
    writeLock?: utils.async.Lock,
    brakesman?: Brakesman,
): Promise<void> {
    const payloadEntry: SharePayloadEntry | null = await getPayloadEntry(entry, writeLock, brakesman);

    if (payloadEntry == null) {
        return;
    }

    return shareMultiple([payloadEntry]).promise;
}

export interface ShareRequest {
    promise: Promise<void>;
    cancel: VoidFunction;
}

export function shareMultiple<ProgressType extends RequestProgress = RequestProgress>(
    payload: Array<SharePayloadEntry>,
    progressCallback?: SendMessageCallbacks<ProgressType>['progress'],
    cameraRoll?: boolean,
): ShareRequest {
    let transactionId: number | undefined;
    const promise: Promise<void> = sendMessage<Message<PayloadEntries>, void, ProgressType>(
        {
            type: !cameraRoll ? 'share' : 'camera_roll',
            action: 'content',
            arguments: {
                payload,
            }
        },
        false,
        MessageTimeout,
        {
            transactionId: (value: number): void => {
                transactionId = value;
            },
            progress: progressCallback
        }
    );

    return {
        promise,
        cancel: wrapForSingleUse((): void => {
            if (transactionId != null) {
                return cancelDownload(transactionId);
            }
        })
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Share.ts